module.exports = __webpack_public_path__ + "static/media/Hotspot.98207776.svg";